import { setContext } from 'apollo-link-context';
import firebase from '../../firebase';
import condominiumContextGql from '../../../utils/condominium-context.gql';

export default () =>
  setContext(async (_, { headers, cache }) => {
    let condominium;
    try {
      const data = cache.readQuery({ query: condominiumContextGql });
      condominium = data.condominiumContext.condominium;
      // eslint-disable-next-line no-empty
    } catch (e) {}

    const { currentUser } = await firebase.auth();

    if (!currentUser) return { headers };

    const token = await currentUser.getIdToken();

    const authorizationHeaders = {
      authorization: token,
    };

    return {
      headers: {
        ...headers,
        ...authorizationHeaders,
        condominium,
      },
    };
  });
